import { defineCapability } from './internal';
export const RELOAD_PAGE_CAP = defineCapability({
  name: 'RELOAD_PAGE_CAP',
  args: {}
});